import React from 'react'

import {t} from '@lib/helpers'
import {
  awsPartnerBadge,
  CONTACT_URL,
  heroBackgroundImage,
  html,
  PARTNER_AWS_SOLUTION_SECTION_ID,
} from './constant'

export default function Header() {
  return (
    <section
      className='PartnerAws__header'
      style={{backgroundImage: `url(${heroBackgroundImage})`}}
    >
      <div className='PartnerAws__inner PartnerAws__header__inner'>
        <div className='PartnerAws__header__text'>
          <h1 className='PartnerAws__header__title'>
            {t('pages.partnerAws.header.titleLine1')}
            <br />
            <span className='PartnerAws__gradient-text'>
              {t('pages.partnerAws.header.titleHighlight')}
            </span>
            <br />
            {t('pages.partnerAws.header.titleLine3')}
          </h1>

          <p
            className='PartnerAws__header__description'
            {...html(t('pages.partnerAws.header.description'))}
          />

          <div className='PartnerAws__header__cta'>
            <a
              className='PartnerAws__button PartnerAws__button--gradient'
              href={`#${PARTNER_AWS_SOLUTION_SECTION_ID}`}
            >
              {t('pages.partnerAws.header.primaryButton')}
            </a>
            <a
              className='PartnerAws__button PartnerAws__button--transparent-white'
              href={CONTACT_URL}
            >
              {t('pages.partnerAws.header.secondaryButton')}
            </a>
          </div>
        </div>

        <div className='PartnerAws__header__badge'>
          <img
            src={awsPartnerBadge}
            alt={t('pages.partnerAws.header.badgeAlt')}
          />
        </div>
      </div>
    </section>
  )
}
